import { render } from "./bodyPage.vue?vue&type=template&id=4a5a0675&scoped=true"
import script from "./bodyPage.vue?vue&type=script&lang=js"
export * from "./bodyPage.vue?vue&type=script&lang=js"

import "./bodyPage.vue?vue&type=style&index=0&id=4a5a0675&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5a0675"]])

export default __exports__